import { gql } from '@apollo/client'
import { useEffect, useMemo } from 'react'

import { ARTIFACT_LABEL } from '../../../constants'
import { useMetrics } from '../../../hooks'
import { useDoctrineData } from '../hooks/use-doctrine-data'
import { DocPopoverDoctrineQuery } from './__generated__/doc-popover-doctrine.graphql'
import { DoctrineContent } from './doctrine-content'
import styles from './styles.module.scss'

export type DocPopoverDoctrineProps = {
  query: DocPopoverDoctrineQuery
}

export function DocPopoverDoctrine(props: DocPopoverDoctrineProps) {
  const {
    query: {
      root: { topic },
    },
  } = props

  const { ref: dispatcherRef, sendCopyEvents, sendMetrics } = useMetrics<HTMLDivElement>()
  const data = useDoctrineData({ topic })
  const defaultProps = useMemo(() => {
    return {
      from_component: 'DoctrinePopover',
      metadata: {
        topicId: topic?.tid,
        topicType: topic?.topicType,
        popover: {
          doc_id: data?.doc.docId,
          artifact: ARTIFACT_LABEL.DOUTRINA,
        },
      },
    }
  }, [data, topic])

  useEffect(() => {
    sendMetrics('Doc.PopoverOpened', defaultProps)
  }, [sendMetrics, defaultProps])

  // caught by the error boundary
  if (!data) throw new Error('Topic not found')

  const onCopy = () => sendCopyEvents()

  return (
    <div className={styles.contentRoot} onCopy={onCopy} ref={dispatcherRef}>
      <DoctrineContent data={data} />
    </div>
  )
}

DocPopoverDoctrine.query = gql`
  query DocPopoverDoctrine($tid: Int!) {
    root {
      topic(tid: $tid) {
        tid
        topicType
        ...UseDoctrineData_topic
      }
    }
  }

  ${useDoctrineData.fragments.topic}
`
